function getStylesRef(refName) {
  return `___ref-${refName || ""}`;
}

export { getStylesRef };
//# sourceMappingURL=get-styles-ref.js.map
